// extracted by mini-css-extract-plugin
export default {"container":"SelectSpecs_container__GlhA0","message":"SelectSpecs_message__by5RQ","body":"SelectSpecs_body__b7el0"};